import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=6756c382&scoped=true"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordView.vue?vue&type=style&index=0&id=6756c382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6756c382",
  null
  
)

export default component.exports